export enum ButtonPalettes {
	DEFAULT,
	SUBDUED,
	PRIMARY,
	SUCCESS,
	CRITICAL,
}
